// introduced layout shift
window.addEventListener('DOMContentLoaded', () => {
  const vimeoWrapper = document.querySelector('.layout_class');
   if (vimeoWrapper){
   // Set an initial fixed height
   vimeoWrapper.style.height = '900px';
   vimeoWrapper.style.maxHeight = 'none';
   vimeoWrapper.style.backgroundColor = '#ddd';
    // Wait for a delay before allowing it to adjust
    setTimeout(() => {
     vimeoWrapper.style.height = '555px';
     vimeoWrapper.style.backgroundColor = '#ddd';
    }, 500);
}
});
